export default [
  {
    type: 'index',
    formItems: [
      {
        label: "页面名称",
        name: "title",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '大转盘活动',
        help:"最多不超过8个字",
        maxLength:8
      },
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 750*1200 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/trunTableDefault.png',
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#fa6455',
      },
      {
        label: "转盘距离顶部",
        name: "top",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "奖项内容",
        name: "is_show_content",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "中奖名单",
        name: "is_show_list",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "显示控制",
        name: "showKey",
        type: "text",
        stamp: 'checkbox',
        key: "params",
        help:'勾选需要显示的字段',
        options: [
          { label: '云店商城', value: 'store' },
          { label: '会员中心', value: 'user' },
        ],
      },
      {
        label: "是否显示导购入口",
        name: "is_show_guide",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
    ]
  },
  {
    type: 'win',
    formItems: [
      {
        label: "标题文字颜色",
        name: "titleColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "奖项文字颜色",
        name: "awardColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "弹窗背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 660*920 ,图片大小500kb以内"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FF3030',
      },
      {
        label: "按钮背景图",
        name: "backgroundButtomImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 300*88 ,图片大小500kb以内"
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FFAE59',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "积分提示语",
        name: "jifenTips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '已到账，请前往会员中心查看',
      },
      {
        label: "红包提示语",
        name: "rebTips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '红包将在24小时内发放',
      },
      {
        label: "累计红包提示语",
        name: "envelopesRebTips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '累计满0.3元即可提现',
      },
      {
        label: "优惠券提示语",
        name: "couponTips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '已到账，请前往会员中心查看',
      },
    ]
  },
  
  {
    type: 'repeat',
    formItems: [
      {
        label: "弹窗背景图片",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 600*600 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/packages.png',
      },
      {
        label: "提示语",
        name: "tips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '奖品已被领取',
      },
      {
        label: "提示语颜色",
        name: "tipsColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#8E0707',
      },
      {
        label: "弹窗背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "按钮背景",
        name: "backgroundButtomImage",
        key: "style",
        stamp: 'singleImage'
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FFAE59',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
  {
    type: 'success',
    formItems: [
      {
        label: "弹窗背景图片",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 600*600 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/packages.png',
      },
      {
        label: "提示语",
        name: "tips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '奖品领取成功可前往会员中心，查看中奖信息',
      },
      {
        label: "提示语颜色",
        name: "tipsColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#8E0707',
      },
      {
        label: "弹窗背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "按钮背景",
        name: "backgroundButtomImage",
        key: "style",
        stamp: 'singleImage'
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FFAE59',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
  {
    type: 'notWinning',
    formItems: [
      {
        label: "弹窗背景图片",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 600*600 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/packages.png',
      },
      {
        label: "提示语",
        name: "tips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '谢谢您的参与,可前往会员中心查看历史中奖信息',
      },
      {
        label: "提示语颜色",
        name: "tipsColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#8E0707',
      },
      {
        label: "弹窗背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "按钮背景",
        name: "buttonImage",
        key: "style",
        stamp: 'singleImage',
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FFAE59',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
  {
    type: 'orderFrom',
    formItems: [
      {
        label: "标题文字颜色",
        name: "titleColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#333333',
      },
      {
        label: "弹窗背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 660*814  ,图片大小500kb以内",
      },
      {
        label: "背景色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#fff',
      },
      {
        label: "按钮背景",
        name: "backgroundButtomImage",
        key: "style",
        stamp: 'singleImage',
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FF0E41',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
  {
    type: 'collect',
    formItems: [
      {
        label: "标题文字颜色",
        name: "titleColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#333333',
      },
      {
        label: "描述文字颜色",
        name: "desColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#333333',
      },
      {
        label: "弹窗背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 660*814  ,图片大小500kb以内",
      },
      {
        label: "背景色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#fff',
      },
      {
        label: "按钮背景",
        name: "backgroundButtomImage",
        key: "style",
        stamp: 'singleImage',
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FF0E41',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
  {
    type: 'double',
    formItems: [
      {
        label: "头部背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 598*220  ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/double.gif',
      },
      {
        label: "文字颜色",
        name: "color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FDE1A2',
      },
      {
        label: "文字提示",
        name: "tips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '尊贵的会员 您的奖项已倍增',
      },
    ]
  },
]